import React from "react";
import WagerTypesConst from "./WagersConstants";

const MessageDetail = ({ info, racesStatus }) => {
  const headerDetails = (badge, type, info) => {
    return (
      <>
        <h4>
          <span className="badge" style={{ backgroundColor: badge }}>
            {type}
          </span>
        </h4>
        <label
          style={{ fontWeight: "bold", fontSize: "22px", color: "#006699" }}
        >
          {info.TrackCode} {info.TrackName && "-"} {info.TrackName}
        </label>
        <label>
          Race #:{" "}
          <span style={{ fontWeight: "bold", fontSize: "16px" }}>
            {info.RaceNumber}
          </span>
        </label>
      </>
    );
  };

  const footerDetails = (info) => {
    return (
      <>
        <hr />
        {info.RaceID !== -1 && info.MessageType !== "operator" && (
          <div>
            Race ID: &nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.RaceID}
            </span>
          </div>
        )}
        {info.ServiceName && (
          <div>
            Source:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.MessageType === "operator" ? "Feed" : info.ServiceName}
            </span>
          </div>
        )}
        {info.GameProvider && (
          <div>
            Provider:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.GameProvider}
            </span>
          </div>
        )}

        {info.MessageType === "operator" && (
          <div>
            Provider:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>RDS</span>
          </div>
        )}
        <div>
          IP:&nbsp;
          <span style={{ fontWeight: "bold", fontSize: "16px" }}>
            {info.ComputerIP}
          </span>
        </div>
      </>
    );
  };
  switch (info.MessageType) {
    case "process":
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(window.config.SiteColors.process, "Process", info)}
          <h5>{info.Message}</h5>
          {footerDetails(info)}
        </div>
      );
    case "race-change":
      let label = "Race";
      label = info.MessageType === "entry-change" ? "Entry" : label;
      if (info.Field === "RaceStatus") {
        return (
          <div className="row m-2" style={{ color: "black" }}>
            {headerDetails(window.config.SiteColors.update, label, info)}
            <h5 className=" text-start">
              Race status changed: from{" "}
              {info.OldValue === "" ? "Empty" : racesStatus(info.OldValue)} to{" "}
              {info.NewValue === "" ? "Empty" : racesStatus(info.NewValue)}
              <br></br>
              <br></br>
            </h5>
            {footerDetails(info)}
          </div>
        );
      }
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(window.config.SiteColors.update, label, info)}
          <label className=" text-start">
            Field Changed: &nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.Field}
            </span>
            <br />
            New Value:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.NewValue === "" ? "Empty" : info.NewValue}
            </span>
            <br />
            Old Value:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.OldValue === "" ? "Empty" : info.OldValue}
            </span>
          </label>
          {footerDetails(info)}
        </div>
      );
    case "entry-change":
      let newValue = info.NewValue === "" ? "Empty" : info.NewValue,
        oldValue = info.OldValue === "" ? "Empty" : info.OldValue;

      newValue = newValue === "-1" ? "SCR" : info.NewValue;
      oldValue = oldValue === "-1" ? "SCR" : info.OldValue;
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(window.config.SiteColors.update, "Entry", info)}

          <label>
            Entry #:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.SaddleNum}
            </span>
          </label>
          <label className=" text-start">
            Field Changed:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {info.Field}
            </span>
            <br></br>
            New Value:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {newValue}
            </span>
            <br></br>
            Old Value:&nbsp;
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {oldValue}
            </span>
          </label>
          {footerDetails(info)}
        </div>
      );
    case "race-create":
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(window.config.SiteColors.create, "Race", info)}
          <h5>
            Insert Race# {info.RaceNumber && info.RaceNumber} from{" "}
            {info.TrackName && info.TrackName}
          </h5>
          <br />
          <ul className="">
            {info.Object.PostTime && (
              <li className="list-group-item">
                PostTime: {info.Object.PostTime}
              </li>
            )}
            {info.Object.Distance && (
              <li className="list-group-item">
                Distance: {info.Object.Distance}
              </li>
            )}
            {info.Object.Surface && (
              <li className="list-group-item">
                Surface: {info.Object.Surface}
              </li>
            )}
            {info.Object.Class && (
              <li className="list-group-item">Class: {info.Object.Class}</li>
            )}
            {info.Object.Purse !== 0 && (
              <li className="list-group-item">Purse: {info.Object.Purse}</li>
            )}
          </ul>
          {footerDetails(info)}
        </div>
      );
    case "entry-create":
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(window.config.SiteColors.create, "Entry", info)}
          <h5 className=" text-start">
            Create Entry {info.Object.SaddleNum ? info.Object.SaddleNum : ""}
            {info.Object.EntryName ? info.Object.EntryName : ""}
          </h5>
          <ul className="">
            {info.Object.RiderName && (
              <li className="list-group-item">
                Rider Name: {info.Object.RiderName}
              </li>
            )}
            {info.Object.TrainerName && (
              <li className="list-group-item">
                Trainer Name: {info.Object.TrainerName}
              </li>
            )}
            {info.Object.OwnerName && (
              <li className="list-group-item">
                Owner Name: {info.Object.OwnerName}
              </li>
            )}
            {info.Object.Ml !== 0 && (
              <li className="list-group-item">Ml: {info.Object.Ml}</li>
            )}
          </ul>
          {footerDetails(info)}
        </div>
      );
    case "pool":
      var tableContent = [];
      info.Object.forEach((item) => {
        let entryNumColor = { backgroundColor: "gray" };

        switch (item.EntryNumber) {
          case 1:
            entryNumColor = { backgroundColor: "red" };
            break;
          case 2:
            entryNumColor = { backgroundColor: "lightblue" };
            break;
          case 3:
            entryNumColor = { backgroundColor: "blue" };
            break;
          case 4:
            entryNumColor = { backgroundColor: "orange" };
            break;
          case 5:
            entryNumColor = { backgroundColor: "#156312" };
            break;
          case 6:
            entryNumColor = { backgroundColor: "gray" };
            break;
          case 7:
            entryNumColor = { backgroundColor: "#F87603" };
            break;
          case 8:
            entryNumColor = { backgroundColor: "#FF84C5" };
            break;
          case 9:
            entryNumColor = { backgroundColor: "lightBlue" };
            break;
          case 10:
            entryNumColor = { backgroundColor: "#8254FB" };
            break;
          case 11:
            entryNumColor = { backgroundColor: "#858585" };
            break;
          case 12:
            entryNumColor = { backgroundColor: "#279214" };
            break;
          case 13:
            entryNumColor = { backgroundColor: "#472706" };
            break;
          case 14:
            entryNumColor = { backgroundColor: "#731B49" };
            break;
          case 15:
            entryNumColor = { backgroundColor: "#8B5B29" };
            break;
          case 16:
            entryNumColor = { backgroundColor: "#6786B0" };
            break;
          case 17:
            entryNumColor = { backgroundColor: "#102EA0" };
            break;
          case 18:
            entryNumColor = { backgroundColor: "#0F5A0A" };
            break;
          case 19:
            entryNumColor = { backgroundColor: "#11487E" };
            break;
          default:
            break;
        }

        tableContent.push(
          <tr key={item.EntryNumber}>
            <td>
              <span className="badge rounded-circle p-1" style={entryNumColor}>
                {item.EntryNumber}
              </span>
            </td>
            <td>$ {item.WinTotal}</td>
            <td>$ {item.PlaceTotal}</td>
            <td>$ {item.ShowTotal}</td>
          </tr>,
        );
      });
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(window.config.SiteColors.create, "Pool", info)}
          <label className=" text-start" style={{ fontWeight: "bold" }}>
            Create Pool in Race{" "}
            <span style={{ fontWeight: "bold", color: "#006699" }}>
              {info.RaceNumber && info.RaceNumber}
            </span>{" "}
            from{" "}
            <span style={{ fontWeight: "bold", color: "#006699" }}>
              {info.TrackName}
            </span>
          </label>
          <table className="table table-striped table-bordered text-center table-sm">
            <thead>
              <tr className="text-center table-sm">
                <th></th>
                <th>Win</th>
                <th>Place</th>
                <th>Show</th>
              </tr>
            </thead>
            <tbody className="table-bordered table-sm text-center">
              {tableContent}
            </tbody>
          </table>
          {footerDetails(info)}
        </div>
      );
    case "close":
    case "error":
    case "warning":
      var color = window.config.SiteColors.close;
      color =
        info.MessageType === "error" ? window.config.SiteColors.error : color;
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(
            info.MessageType === "warning"
              ? window.config.SiteColors.warning
              : color,
            info.MessageType.toUpperCase(),
            info,
          )}
          <h6>{info.Message}</h6>
          {footerDetails(info)}
        </div>
      );
    case "result-create":
      if (info.Errors && info.Errors.length !== 0) {
        let exotics = [];
        WagerTypesConst.forEach((poolType, index) => {
          if (
            info.WrongObject[poolType.name] &&
            info.WrongObject[poolType.name].length !== 0
          ) {
            info.WrongObject[poolType.name].forEach((item) => {
              exotics.push(
                <div className="row" key={index}>
                  <div className="col"> {poolType.name}: </div>
                  <div className="col"> {item.Selections} </div>
                  <div className="col"> $2 - {item.Payout}</div>
                </div>,
              );
            });
          }
        });
        return (
          <div className="row m-2" style={{ color: "black" }}>
            {headerDetails(window.config.SiteColors.create, "Results", info)}
            <h3>These results could not be inserted</h3>
            <ul className="">{exotics}</ul> {footerDetails(info)}
          </div>
        );
      } else {
        const tableResults = info.Object.WPSList.map((result, index) => (
          <tr key={index} className="text-center">
            <td hidden>{result.Entrynum}</td>
            <td>{result.Pos}</td>
            <td>{result.Entrynum}</td>
            <td>{result.Entryname}</td>
            <td>{result.Win === 0 ? "" : result.Win}</td>
            <td>{result.Place === 0 ? "" : result.Place}</td>
            <td>{result.Show === 0 ? "" : result.Show}</td>
          </tr>
        ));
        let exotics = [];
        WagerTypesConst.forEach((poolType, index) => {
          if (
            info.Object[poolType.name] &&
            info.Object[poolType.name].length !== 0
          ) {
            info.Object[poolType.name].forEach((item) => {
              if (
                poolType.name !== "Win" &&
                poolType.name !== "Place" &&
                poolType.name !== "Show"
              ) {
                exotics.push(
                  <div className="row" key={index}>
                    <div className="col"> {poolType.name}: </div>
                    <div className="col"> {item.Selections} </div>
                    <div className="col"> $2 - {item.Payout}</div>
                  </div>,
                );
              }
            });
          }
        });
        return (
          <div className="row m-2" style={{ color: "black" }}>
            {headerDetails(window.config.SiteColors.create, "Results", info)}
            <hr className="mb-0 mt-1" style={{ color: "#a8b3bd" }} />
            <table className="table table-sm">
              <thead className="thead-dark">
                <tr className="text-center">
                  <th hidden>RaceID</th>
                  <th>POS</th>
                  <th>#</th>
                  <th>Entry Name</th>
                  <th>Win</th>
                  <th>Place</th>
                  <th>Show</th>
                </tr>
              </thead>
              <tbody className="table-sm">{tableResults}</tbody>
            </table>
            <ul className="">{exotics}</ul> {footerDetails(info)}
          </div>
        );
      }

    case "Process":
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(window.config.SiteColors.process, "Process", info)}
          <h5>{info.Message}</h5>
          {footerDetails(info)}
        </div>
      );
    case "Score":
    case "UnScore":
      let badge =
        info.MessageType === "UnScore"
          ? window.config.SiteColors.unscore
          : window.config.SiteColors.score;
      return (
        <div className="row m-2" style={{ color: "black" }}>
          {headerDetails(badge, info.MessageType, info)}
          <h5>
            {info.MessageType} Race {info.RaceNumber} from {info.TrackName}
          </h5>
          <h6>Total Tickets: {info.TotalTickets}</h6>
          <h6>Score Tickets: {info.ScoreTickets}</h6>
          <h6>UnScore Tickets: {info.UnScoreTickets}</h6>
          <br />
          {info.Errors && (
            <ul className="list-group list-group-flush">
              <span className="badge bg-danger">Errors</span>
              {info.Errors.map((item, i) => (
                <li key={i} className="list-group-item">
                  {item}
                </li>
              ))}
            </ul>
          )}
          {footerDetails(info)}
        </div>
      );
    case "operator":
      return (
        <div className="row m-2" style={{ color: "black" }}>
          <h4 style={{ fontWeight: "bold" }}>New Feed Message</h4>
          <h5>{info.Message}</h5>
          {footerDetails(info)}
        </div>
      );
    default:
      return <div></div>;
  }
};

export default MessageDetail;
